import img1 from '~/assets/news/n1.webp'
import img2 from '~/assets/news/n2.webp'
import img3 from '~/assets/news/n3.webp'
import img4 from '~/assets/news/n4.webp'
import img5 from '~/assets/news/n5.jpg'
import img6 from '~/assets/news/n6.webp'
import img7 from '~/assets/news/n7.webp'
import img8 from '~/assets/news/n8.webp'

export const newsListSale = [
    {
        href: '#',
        src: img1,
        title: 'Thu cũ đổi mới - nâng cấp PC của bạn ngay'

    },
    {
        href: '#',
        src: img2,
        title: 'Thu cũ đổi mới - nâng cấp PC của bạn ngay'

    },
    {
        href: '#',
        src: img3,
        title: 'Màn hình chơi game chính hãng giá rẻ, đừng bỏ lỡ!!!'

    },
    {
        href: '#',
        src: img4,
        title: 'Tết đến xuân về - siêu sale đón Tết, ưu đãi ngập tràn'

    },
]

export const newsListTech = [
    {
        href: '#',
        src: img5,
        title: 'Hướng dẫn cài đặt Steam và sử dụng chi tiết nhất'
    },
    {
        href: '#',
        src: img6,
        title: 'Các cách xóa tài khoản Facebook cá nhân vĩnh viễn'

    },
    {
        href: '#',
        src: img7,
        title: 'Cách tải và cài đặt Capcut trên PC đơn giản nhất'

    },
    {
        href: '#',
        src: img8,
        title: 'Các cách xóa tài khoản Facebook cá nhân vĩnh viễn'

    },
]